import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-456a2ec5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" (조합원 자격) ")
const _hoisted_3 = { class: "deal-detail" }
const _hoisted_4 = { class: "space-between" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_7 = { class: "space-between" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 판매 금액 ")
const _hoisted_9 = { class: "align-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, "|", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" MY ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, "|", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, "|", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("거래완료 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ag_intersect_box = _resolveComponent("ag-intersect-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_intersect_box, {
      css: {height: 150},
      class: _normalizeClass({disabled:(_ctx.dealInfoRef.status==='saleCompleted')})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box_s, { css: {mb: 8, dp: 'flex'} }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_img, {
              width: "32px",
              height: "32px",
              style: {"flex-shrink":"0"},
              src: _ctx.dealInfoRef.partnershipLogo
            }, null, 8, ["src"]),
            _createVNode(_component_ag_text_s, { css: {dp: 'flex', ml: 8,alignItems: 'center', typography: 'list17m'} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.dealInfoRef.partnershipName) + " ", 1),
                _createVNode(_component_ag_text_s, { css: {typography: 'main16r', color: 'gray2'} }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ag_text_s, { css: {dp: 'flex', alignItems: 'center', color: 'gray3', typography: 'main13r'} }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_ag_text_s, { css: {typography: 'num16bk'} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.dealInfoRef.price)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text_s, { css: {typography: 'main16r'} }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_ag_box_s, { css: {

            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
          } }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', alignItems: 'center', color: 'gray3', typography: 'main12r', bg: 'bg1', borderRadius: '4px', padding:'4px 8px'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_icon, { name: "businessOutline" }),
                  _createVNode(_component_ag_text_s, { css: {ml:'5px'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 기업가치 " + _toDisplayString(_ctx.numberToKorean(_ctx.dealInfoRef.price * _ctx.dealInfoRef.totalStockAmount)) + "원 가격 ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ag_text_s, { css: {color: 'gray3', typography: 'main13r'} }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_ag_text_s, { css: {color: 'main13r'} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.dealInfoRef.totalPrice)) + " 원 ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text_s, { css: {color: 'gray3', typography: 'main13r'} }, {
                default: _withCtx(() => [
                  _createTextVNode(" (약 " + _toDisplayString(_ctx.perCurrency(_ctx.dealInfoRef.qty)) + " 주) ", 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ion_icon, {
              icon: _ctx.personCircleOutline,
              style: {"color":"#D4D9DF","width":"20px","height":"20px","margin-right":"3px"}
            }, null, 8, ["icon"]),
            (!_ctx.dealInfoRef.mine)
              ? (_openBlock(), _createBlock(_component_ag_text_s, {
                  key: 0,
                  css: {typography: 'main13r', color: 'gray3'}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dealInfoRef.publicId) + " ", 1),
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.prettyDateToOnemonth(_ctx.dealInfoRef.createAt)) + " 등록 ", 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_ag_text_s, {
                  key: 1,
                  css: {typography: 'main13r'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, { css: {typography: 'main13r', color: 'primary'} }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.prettyDateToOnemonth(_ctx.dealInfoRef.createAt)) + " 등록 ", 1)
                  ]),
                  _: 1
                })),
            (_ctx.dealInfoRef.status==='saleCompleted')
              ? (_openBlock(), _createBlock(_component_ag_text_s, {
                  key: 2,
                  css: {typography: 'main13r' , color: 'gray3', ml:'3px'}
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}